import { linkProjection } from "./utils";

export const siteSettingsPreviewQuery = '*[_type == "siteSettings"]';

// Note: Using resolveReferences on siteSettings results in way too many requests,
// hence the verbose query projection string.
export const siteSettingsPreviewQueryProjection = `
    {
      "allSanitySiteSettings": {
        "nodes": *[_type == "siteSettings"] {
          ...,
          mainNavigation[] {
            ...,
            firstLevelItems[] {
              ...,
              subitems[] {
                ...,
                link->{
                  ${linkProjection}
                }
              }
            }
          },
          toolNavigation[] {
            ...,
            link {
              ...,
              reference->{
                ${linkProjection}
              }
            }
          },
          promotedLinks[] {
            ...,
            link->{
              ${linkProjection}
            }
          },
          footer {
            ...,
            contactCta {
              ...,
              reference->{
                ${linkProjection}
              }
            },
            linkSections[] {
              links[] {
                ...,
                reference->{
                  ${linkProjection}
                }
              }
            },
            links[] {
              ...,
              reference->{
                ${linkProjection}
              }
            },
            policyLinks[] {
              ...,
              reference->{
                ${linkProjection}
              }
            }
          },
          "routeInfo": {
            "blogList": *[_type == "blogList" && i18nLang == ^.i18nLang][0],
            "pressReleaseList": *[_type == "pressReleaseList" && i18nLang == ^.i18nLang][0],
            "search": *[_type == "search" && i18nLang == ^.i18nLang][0],
          }
        }
      }
    }
  `;
